<template>
  <div class="btn-pet" :class="{ 'btn-pet-active': allSelected }" @click="onPetsSelected">
    <div class="btn-pet-name">All</div>
    <div class="btn-pet-breed">{{petNames}}</div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { PetCacheMixin } from '@/mixins/Booking/PetCacheMixin'
import { PetDurationCacheMixin } from '@/mixins/Booking/PetDurationCacheMixin'
import { SiteBookingSettingMixin } from '@/mixins/Booking/SiteBookingSettingMixin'

export default {
  name: 'PetSelectAll',
  mixins: [PetCacheMixin, PetDurationCacheMixin, SiteBookingSettingMixin],
  props: {
    allSelected: Boolean
  },
  computed: {
    ...mapState('BookingUpload', [
      'defaultDuration'
    ]),
    petsWithPetId () {
      return this.pets.map(pet => ({
        ...pet,
        petId: pet.id,
        serviceItems: [],
        appointmentDuration: this.computePetAppointmentDuration(pet)
      }))
    },
    petNames () {
      return this.pets.map(pet => pet.name).join(', ')
    }
  },
  methods: {
    petProfileDurationMinutes (pet) {
      const profileDuration = this.petDurations.find(d => d.petId === pet.id)
      return profileDuration ? profileDuration.hours * 60 + profileDuration.minutes : 0
    },
    computePetAppointmentDuration (pet) {
      const profileMinutes = this.petProfileDurationMinutes(pet)
      const fixedDuration = profileMinutes > 0 ? profileMinutes : this.defaultDuration
      if (this.siteBookingSettingServiceBasedDurationEnabled) {
        const serviceDuration = (pet.serviceItems ?? []).reduce((sum, item) => sum + (item.durationMinutes || 0), 0)
        return serviceDuration > 0 ? serviceDuration : this.defaultDuration
      }
      return fixedDuration
    },
    onPetsSelected () {
      this.$emit('allPetsSelected', this.petsWithPetId)
    }
  }
}
</script>
